
      import {requestComponentObserver} from 'uni-view/bridge/subscribe/api/request-component-observer.js'
import {destroyComponentObserver} from 'uni-view/bridge/subscribe/api/request-component-observer.js'
import {requestMediaQueryObserver} from 'uni-view/bridge/subscribe/api/request-media-query-observer.js'
import {destroyMediaQueryObserver} from 'uni-view/bridge/subscribe/api/request-media-query-observer.js'
import {requestComponentInfo} from 'uni-view/bridge/subscribe/api/request-component-info.js'
      export default {
        requestComponentObserver,
destroyComponentObserver,
requestMediaQueryObserver,
destroyMediaQueryObserver,
requestComponentInfo
      }
      